// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"eX","bottomColumnWapper":"eX","bottom-column-panel":"eY","bottomColumnPanel":"eY"};